import { combineReducers } from 'redux';
import { creative, creativeGroup } from './creatives/reducers';

export default combineReducers({ creative, creativeGroup });
